import React, { useState } from "react";

import { useQuery } from "react-query";
import { QuizAPI } from "../../Api/Quiz";
import SectionContainer from "../../Components/Container/SectionContainer";
import { Header, SearchInput } from "../../Components/CustomComponent";
import QuizSchedule from "../../Components/QuizSchedule";
import styles from "./index.module.scss";

export default function QuestionHistory() {
  const quizAPI = QuizAPI();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(null);
  const [activeTab, setActiveTab] = useState(10)

  const { data: quizzes = [], isFetching } = useQuery(
    ["quizzes", search, page, activeTab],
    async () => {
      const params = {
        page: page,
        limit: 10,
        search: search || "",
        status: activeTab
      };
      const response = await quizAPI.getQuizzes(params);
      setPagination(response?.links);
      return response;
    },
    {
      // enabled: !!search, // Query runs only when `search` is truthy
      // keepPreviousData: true
    }
  );

  const getRecords = async () => {
    try {
      let temp = page;
      temp = temp + 1;
      setPage(temp);
    } catch (e) { }
  };

  const handleTab = (tab) => {
    setActiveTab(tab)
    setPage(1)
  }

  return (
    <div className={styles.Quiz}>
      <SectionContainer classes={`${styles.container} mx-auto`}>
        <div className="d-block d-md-flex justify-content-between">
          <Header text="Quiz History" />

          <div className={`${styles.tagContainer} align-items-start gap-3 mt-3 mt-md-0 col-12 col-md-6`}>
            <span className={`bg-warning fs-8 rounded-pill fw-bolder p-1 px-3 text-center cursor-pointer ls-9 ${activeTab === 10 ? "border-bottom border-3 text-white " : "text-dark"}`} onClick={() => handleTab(10)}>
              {"Upcoming"}
            </span>
            <span className={`bg-warning fs-8 rounded-pill fw-bolder p-1 px-3 text-center cursor-pointer ls-9 ${activeTab === 20 ? "border-bottom border-3 text-white" : "text-dark"}`} onClick={() => handleTab(20)}>
              {"On Going"}
            </span>
            <span className={`bg-warning fs-8 rounded-pill fw-bolder p-1 px-3 text-center cursor-pointer ls-9 ${activeTab === 30 ? "border-bottom border-3 text-white" : "text-dark"}`} onClick={() => handleTab(30)}>
              {"Over"}
            </span>
            <span className={`bg-warning fs-8 rounded-pill fw-bolder p-1 px-3 text-center cursor-pointer ls-9 ${activeTab === 40 ? "border-bottom border-3 text-white" : "text-dark"}`} onClick={() => handleTab(40)}>
              {"Not Started"}
            </span>
          </div>
        </div>

        <div className={`${styles.serch_div} d-flex flex-column gap-35 mt-3`}>
          <div className="d-flex flex-row align-items-center justify-content-between gap-2">
            <SearchInput setValue={setSearch} value={search} />
          </div>
        </div>
      </SectionContainer>
      <QuizSchedule
        key={activeTab}
        data={quizzes?.data}
        isLoading={isFetching}
        getRecords={getRecords}
        page={page}
        pagination={pagination}
      />
    </div>
  );
}
